import React from "react";
import { QrCodeOverlay } from "../../views/Overlays/QrOverlay";
import Loader from "../../components/Loader";
import { WaitForURLQuery } from "../../components/WaitForURLQuery";
import { useFonts } from "../../components/FontSelector/useFont";

const QR = (query) => {
  const { bodyFont = "IBM Plex Mono" } = query;
  useFonts({ fonts: [{ family: bodyFont }] });
  if (query.username) {
    return <QrCodeOverlay {...query} />;
  }
  return <Loader></Loader>;
};

const QRWidget = () => {
  return <WaitForURLQuery Component={QR} />;
};

export default QRWidget;
